export const PAGE_PLACEHOLDERS_DATA = {
  debatesFeed: 'There are no active debates here at this time.',
  challengesFeed: 'There are no active debate challenges here at this time. Why not create one?',
  myDebates: 'You have no active debates.',
  myChallenges:
    'To start a debate, create a new challenge. Any debate challenges you create will appear here. ',
  pageNotFound: 'Page not found',
  streamIsAboutToStart: 'The debate stream is about to start',
} as const;
